import { Capacitor } from "@capacitor/core";

// Mobile fork is wired to "running as a native app" — not viewport width.
// Desktop browser at any width keeps the desktop layout; the Android (and
// future iOS) Capacitor app gets the mobile-forked versions of dense pages.
export function isNativeMobile() {
  return Capacitor.getPlatform() !== "web";
}
